import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export default function ConditionsPage() {
  return (
    <>
      <Helmet>
        <title>Conditions Générales d'Utilisation – TrackVibes</title>
        <meta name="description" content="Conditions générales d'utilisation de TrackVibes. Découvrez les règles d'utilisation de notre plateforme." />
      </Helmet>
      
      <div className="min-h-screen bg-white">
        <div className="max-w-[900px] mx-auto px-6 py-12">
          {/* Logo */}
          <div className="text-center mb-12">
            <Link to="/">
              <img 
                src="/assets/trackvibes-logo.png" 
                alt="TrackVibes" 
                className="h-16 mx-auto"
              />
            </Link>
          </div>

          {/* Content */}
          <article className="prose prose-gray max-w-none">
            <h1 className="text-3xl font-bold text-gray-900 mb-8">Conditions Générales d'Utilisation</h1>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">1. Objet</h2>
              <p className="text-gray-700 leading-relaxed">
                TrackVibes est une plateforme SaaS permettant aux DJs de centraliser les demandes musicales lors d'événements.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">2. Formules</h2>
              <p className="text-gray-700 leading-relaxed">
                Version Free et Version Pro par abonnement mensuel.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">3. Abonnement Pro</h2>
              <ul className="text-gray-700 leading-relaxed list-disc pl-6 space-y-2">
                <li><strong>Tarif :</strong> 4,99€ / mois</li>
                <li><strong>Essai gratuit :</strong> 14 jours</li>
                <li><strong>Résiliation :</strong> possible à tout moment via Stripe</li>
                <li><strong>Remboursement :</strong> aucun remboursement proratisé</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">4. Responsabilité</h2>
              <p className="text-gray-700 leading-relaxed">
                Le DJ reste responsable des contenus diffusés et du respect des réglementations locales.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">5. Comportement utilisateur</h2>
              <p className="text-gray-700 leading-relaxed">
                Interdiction de publier contenu illégal, offensant ou diffamatoire.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">6. Limitation de responsabilité</h2>
              <p className="text-gray-700 leading-relaxed">
                TrackVibes ne peut être tenu responsable d'un mauvais déroulement d'événement ou d'un choix musical.
              </p>
            </section>
          </article>

          {/* Footer */}
          <footer className="mt-16 pt-8 border-t border-gray-200">
            <nav className="flex justify-center gap-6 text-sm text-gray-600">
              <Link to="/privacy" className="hover:text-gray-900">Confidentialité</Link>
              <span className="text-gray-300">|</span>
              <Link to="/conditions" className="hover:text-gray-900 font-medium">Conditions</Link>
              <span className="text-gray-300">|</span>
              <Link to="/mentions-legales" className="hover:text-gray-900">Mentions légales</Link>
            </nav>
            <p className="text-center text-gray-400 text-xs mt-4">© 2026 TrackVibes. Tous droits réservés.</p>
          </footer>
        </div>
      </div>
    </>
  );
}
